"use client";

import axios from "axios";
import { IHubSpotForm } from "@/sanity/globals/HubspotForm";

function getCookie(name: string) {
  let cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookiePair = cookieArray[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

export interface HubspotForm {
  portalId: string;
  formId: string;
  fields: {
    name: string;
    value: string;
  }[];
  context: {
    hutk?: string;
    pageUri: string;
    pageName: string;
  };
}
export async function submitForm(data: HubspotForm) {
  const hutk = getCookie("hubspotutk");
  if (hutk && hutk.length > 0) {
    data.context["hutk"] = hutk;
  }
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${data.portalId}/${data.formId}`;
  return await axios.post(url, data);
}

export async function submitFormDataToHubSpot(
  fieldData: any,
  formData: IHubSpotForm,
  pageURI: string,
  pageName: string
) {
  const data = {
    portalId: formData.settings.portalId,
    formId: formData.settings.formId,
    fields: Object.entries(fieldData).map(([key, value]) => ({
      name: key,
      value: value as string,
    })),
    context: {
      pageUri: pageURI,
      pageName: pageName,
    },
  };

  try {
    const res = await submitForm(data);
    if (res?.status == 200) {
      return {
        success: true,
        message: "Form submitted successfully",
        submission: res,
      };
    }

    return {
      success: false,
      message: "Form submission failed",
    };
  } catch (e) {
    console.log(e);
    return {
      success: false,
      message: "Form submission failed",
    };
  }
}
